import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './LandingPage.css';

function LandingPage() {
  const [url, setUrl] = useState('');
  const navigate = useNavigate();

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (url) {
      // Navigate to signup page with URL parameter
      navigate('/signup', { state: { websiteUrl: url } });
    }
  };

  const processSteps = [
    {
      emoji: '🔍',
      title: 'Find',
      description: 'Find relevant influencers that your competitors have already collaborated with'
    },
    {
      emoji: '💰',
      title: 'Negotiate',
      description: 'Negotiate the rate to get reasonable price based on their audience, post views to achieve great ROAS'
    },
    {
      emoji: '📱',
      title: 'Publish',
      description: 'Analyze script & video draft → if you approve, it is posted'
    },
    {
      emoji: '💳',
      title: 'Payment',
      description: 'AI deliver the PayPal invoice and tax form'
    },
    {
      emoji: '📊',
      title: 'Evaluate',
      description: 'AI monitors the ROAS, views, and engagement'
    },
    {
      emoji: '🔄',
      title: 'Continue',
      description: 'If it is profitable we continue the long term collaboration with the influencer'
    }
  ];

  return (
    <div className="landing-container">
      <div className="hero-section">
        <div className="hero-content">
          <h1 className="landing-title">
            Turn Your Website Into <span className="highlight">Influencer Viral Posts</span>
          </h1>
          <p className="landing-subtitle">
            Just drop your Website URL. Our AI will start the influencer marketing campaign in scale.
          </p>
          <form onSubmit={handleSubmit} className="landing-form">
            <input
              type="url"
              placeholder="Enter your website URL"
              value={url}
              onChange={(e) => setUrl(e.target.value)}
              className="landing-input"
              required
            />
            <button type="submit" className="landing-button">
              Go Viral
            </button>
          </form>
        </div>
      </div>

      <div className="process-section">
        <h2 className="process-section-title">How It Works</h2>
        <div className="process-grid">
          {processSteps.map((step, index) => (
            <div key={index} className="process-card">
              <div className="process-number">{index + 1}</div>
              <div className="process-emoji">{step.emoji}</div>
              <h3 className="process-title">{step.title}</h3>
              <p className="process-description">{step.description}</p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default LandingPage;